import Lottie from "lottie-react";

import botAnimation from "../../Assets/animation/lottieErrorBot.json";
import { useEffect, useMemo } from "react";
import BasicModal from "./BasicModal";

function MessageModal({ messageModal = {}, updateMessageModal = () => {} }) {
  const {
    isVisible = false,
    header = "Success",
    showBotAnimation = true,
    message = "Empty message",
    timeout = 30000,
    headerBg = "red",
  } = messageModal;

  useEffect(() => {
    if (!isVisible) {
      return;
    }

    const timeoutModal = setTimeout(() => {
      updateMessageModal({ isVisible: false });
    }, timeout);

    return () => {
      clearTimeout(timeoutModal);
    };
  }, [isVisible]);

  return (
    <BasicModal
      bg={headerBg}
      header={header}
      isVisible={isVisible}
      setIsVisible={() => updateMessageModal({ isVisible: false })}
    >
      <BotAnimation showBotAnimation={showBotAnimation} />
      <div className=" p-1 flex flex-wrap  items-center gap-x-4 w-[90vw] md:w-[40vw] ">
        <SmartMessage message={message} />
      </div>
    </BasicModal>
  );
}

function BotAnimation(props) {
  const { showBotAnimation } = props;
  if (!showBotAnimation) {
    return null;
  }
  return (
    <div className=" " style={{ width: "10em" }}>
      <Lottie animationData={botAnimation} />
    </div>
  );
}

function SmartMessage({ message }) {
  if (!message) return null;

  if (typeof message === "string") {
    const isHTML = /<\/?[a-z][\s\S]*>/i.test(message);
    if (isHTML) {
      return <div dangerouslySetInnerHTML={{ __html: message }} />;
    }
    return <p>{message}</p>;
  }

  if (Array.isArray(message)) {
    return (
      <div className=" flex flex-col gap-y-1">
        {message.map((item, index) => (
          <div key={index}>{item}</div>
        ))}
      </div>
    );
  }

  return null;
}

export default MessageModal;
